
import Vue from 'vue';

// @nuxt/image@0.x's `sizes`-based srcset only emits one width per breakpoint,
// so retina screens get blurry, undersized images. Doubling every numeric size
// value and generating a second srcset via the same algorithm gives us proper
// 2x entries alongside the 1x ones.
function doubleSizes(sizes: string): string {
  return sizes
    .split(/\s+/)
    .filter(Boolean)
    .map(entry => {
      const [key, value] = entry.split(':');
      if (!value) return entry;
      return `${key}:${value.replace(/\d+(\.\d+)?/, match => String(parseFloat(match) * 2))}`;
    })
    .join(' ');
}

export default Vue.extend({
  props: {
    src: {
      type: String,
      default: 'https://lorempic.jvm-neckar.net/1200x800/DEEBD4/0F3228?text=mood&texture=cross',
    },
    alt: {
      type: String,
      default: 'Image Alt text',
    },
    title: {
      type: String,
      default: 'Image Title',
    },
    ratio: {
      type: String,
      default: '3to2',
    },
    caption: {
      type: String,
    },
    sizes: {
      type: String,
      default: 'sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw 4xl:100vw',
    },
    focus: {
      type: String,
    },
    noRatio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    setImageLoaded(): void {
      this.isLoaded = true;
    },
  },
  computed: {
    focalPoint(): any {
      return this.focus ? { filters: { focal: this.focus } } : { smart: true };
    },
    dimensions(): any {
      if (this.noRatio) return undefined;

      const dimensions = this.ratio.split('to');

      return {
        width: dimensions[0],
        height: dimensions[1],
      };
    },
    computedImage(): { src: string; srcset?: string; sizes?: string } {
      const modifiers = {
        ...this.focalPoint,
        quality: 80,
        width: this.dimensions?.width,
        height: this.dimensions?.height,
      };
      const opts = { sizes: this.sizes, modifiers, provider: 'storyblok' };

      const base = (this as any).$img.getSizes(this.src, opts);
      const dense = (this as any).$img.getSizes(this.src, { ...opts, sizes: doubleSizes(this.sizes) });

      return {
        src: base.src || (this as any).$img(this.src, modifiers, { provider: 'storyblok' }),
        srcset: [base.srcset, dense.srcset].filter(Boolean).join(', ') || undefined,
        sizes: base.sizes || undefined,
      };
    },
  },
});
